// STAFF-SESSIONS-1 (30 Oct 2026, audit SCRM-06 / H6) — staff session renewal.
//
// Staff tokens last 12 hours (backend config.JWT_EXPIRATION_HOURS_STAFF). While
// the person is actually using the app, AuthContext swaps in a fresh token from
// POST /auth/session/renew, so a working day never ends in "Token expired".
// An idle tab stops renewing, so its session ends 12 hours after it was last
// used. The backend caps renewal at 7 days from the sign-in itself.
//
// Pure helpers here so they can be unit-tested without React.

export const STAFF_ROLES = ["admin", "super_admin", "broker", "junior_broker"];

// Renew once the token is at least this old…
export const RENEW_AFTER_MS = 30 * 60 * 1000;
// …but only if someone touched the app within this window.
export const ACTIVE_WITHIN_MS = 30 * 60 * 1000;
// How often the tab checks.
export const CHECK_EVERY_MS = 5 * 60 * 1000;

export function decodeJwt(token) {
  try {
    const part = String(token || "").split(".")[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isStaffRole(role) {
  return STAFF_ROLES.includes(role);
}

/** Should this tab renew `token` now? `now` and `lastActivity` are ms epochs. */
export function shouldRenew(token, { now, lastActivity }) {
  const claims = decodeJwt(token);
  if (!claims || !isStaffRole(claims.role) || claims.kind) return false;
  const exp = (claims.exp || 0) * 1000;
  if (exp && exp <= now) return false; // already dead; the next request signs them out
  const issued = (claims.iat || 0) * 1000;
  if (!issued || now - issued < RENEW_AFTER_MS) return false;
  return now - lastActivity <= ACTIVE_WITHIN_MS;
}
